export enum LocalStorageKey {
  TOKEN = 'token',
  USER_TYPE = 'userType',
}
